module.exports = __webpack_public_path__ + "media/images/icons/twotone/euro-02b09469ee919f6c437fac576ccca78e.svg";